import React from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles({
  color: {
    borderColor: (props) => props.color,
  },
});

export const TimelineLog = ({ log, color }) => {
  const classes = useStyles(color);

  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot variant="outlined" className={classes.color} />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <Typography variant="body2">{log.message} on {moment(log.created_at).format('MM-DD-YYYY h:mm A')}</Typography>
      </TimelineContent>
    </TimelineItem>
  );
};

export default TimelineLog;